import UserHOC from "../../../components/shared/HOC/UserHOC";
import CommonTable from "../../../components/shared/table/Table";
import { useMyCoursesData } from "../../../hooks/UserHooks/MyCoursesHook/useMyCourses";
import { getColumns } from "../../../assets/constants/user/my-courses";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../../components/global/CustomInput/CustomInput";
import { useState } from "react";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import searchIconsvg from "../../../assets/icons/Search-Icon.svg"

const MyCourses = () => {
    const [isInputHovered, setIsInputHovered] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const columns = getColumns(navigate);
  const { data, loading, paginationConfig, handlePageChange } =
    useMyCoursesData(search);

  return (
    <div className="rounded-[10px] border p-4 border-[#e8e8e8] bg-white shadow-[0_0_6px_#0000000D] overflow-visible">
      <div className="flex justify-between mb-4">
        <p className="font-medium text-[28px] text-[#E74860]">
          My Enrolled Courses
        </p>

        <CustomInput
        icon={
                      isInputHovered ? (
                        <LottieIcon name="searchIcon" size={24} shouldPlay={true} />
                      ) : (
                        <img
                          src={searchIconsvg}
                          alt="search"
                          style={{ width: 24, height: 24 }}
                        />
                      )
                    }
                                onMouseEnter={() => setIsInputHovered(true)}
            onMouseLeave={() => setIsInputHovered(false)}
          placeholder="Search"
          className="w-[300px]"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <CommonTable
        data={data}
        scroll={{ y: "48vh", x: "max-content" }}
        className="hide-scrollbar top-table-radius"
        columns={columns}
        showLoader={loading}
        pagination={paginationConfig}
        onChange={handlePageChange}
        serverSide={true}
        rowClickable={true}
        hover = {true}
        settingModalDataFunction={(record) =>
          navigate(`/my-courses/course-content-user/${record.courseId}`)
        }
      />
    </div>
  );
};

export default UserHOC(MyCourses);
